import { NgxMaskDirective } from 'ngx-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';

import { UiModule } from '@lockton-apps/shared/ui/lui';
import { MatIconModule } from '@angular/material/icon';
import { AddressTypeComponent } from './address-type.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [AddressTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective,

    FormlyModule.forChild({
      types: [
        {
          name: 'address',
          component: AddressTypeComponent,
        },
      ],
    }),
    UiModule,
    MatIconModule,
    MatAutocompleteModule,
    MaterialModule,
  ],
})
export class AddressTypeModule {}
